import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import { storeToRefs } from 'pinia';
import OurProjectsDialog from '~/core/components/OurProjectsDialog/OurProjectsDialog.vue';
import { DIALOG_MESSAGE as CORE_DIALOG } from '~/core/constants';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import { useLogout } from '~/core/composables';
import { ymGoal } from '~/core/utils/yandexReachGoal';
import useLocaleStore from '~/stores/useLocaleStore';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useTownModalStore from '~/stores/useTownModalStore';
import useMedcardStore from '~/stores/useMedcardStore';
import useProfileStore from '~/stores/useProfileStore';
import useDoctorsAndClinicsStore from '~/stores/useDoctorsAndClinicsStore';
import { MedcardStatus } from '~/features/Profile/enums';
export default defineComponent({
  name: 'AppMenu',
  components: {
    OurProjectsDialog: OurProjectsDialog
  },
  props: {
    value: {
      type: Boolean
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var profileStore = useProfileStore();
    var medcardStore = useMedcardStore();
    var _storeToRefs = storeToRefs(useDoctorsAndClinicsStore()),
      showDoctorsAndClinics = _storeToRefs.showAppMenuButton;
    var _storeToRefs2 = storeToRefs(medcardStore),
      medcardStatus = _storeToRefs2.status;
    var _useRoute = useRoute(),
      routeName = _useRoute.name;
    var _useLogout = useLogout(),
      logout = _useLogout.logout;
    var $dialog = useMainDialogStore();
    var $snackbar = useMainSnackbarStore();
    var locale = useLocaleStore();
    var townModalStore = useTownModalStore();
    var isOurProjectsDialogActive = ref(false);
    var hasUnreadNotifications = computed(function () {
      return profileStore.unreadNotificationsCount > 0;
    });
    var isUserLogged = computed(function () {
      return profileStore.phone;
    });
    var medcardStatusText = computed(function () {
      switch (medcardStatus.value) {
        case MedcardStatus.Protected:
          return null;
        case MedcardStatus.Expired:
          return 'Заблокирована';
        case MedcardStatus.NeedConfirmation:
          return 'Подтвердите доступ';
      }
    });
    var townName = computed(function () {
      return profileStore.town;
    });
    function handleClickTown() {
      townModalStore.open();
    }
    function isCurrentPath(name) {
      return routeName === name;
    }
    function handleClickMedcard() {
      ymGoal('clickMK');
    }
    function handleClickAppointment() {
      ymGoal('clickMyAppointments');
    }
    function handleClickFavourites() {
      ymGoal('clickFavourites');
    }
    function handleClickProfile() {
      ymGoal('clickProfile');
    }
    function handleClickRates() {
      ymGoal('clickMyRates');
    }
    function handleLogout() {
      return _handleLogout.apply(this, arguments);
    }
    function _handleLogout() {
      _handleLogout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isResolved;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return $dialog.open(_objectSpread({}, CORE_DIALOG.LOGOUT_DANGER));
            case 2:
              isResolved = _context.sent;
              if (isResolved) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.prev = 5;
              _context.next = 8;
              return logout();
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              $snackbar.open(CORE_SNACKBAR.ERROR_WITH_RELOAD);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 10]]);
      }));
      return _handleLogout.apply(this, arguments);
    }
    function handleClickPatientLogin() {
      emit('input', false);
    }
    function handleClickLpuLogin() {
      location.assign("".concat(locale.pdUrl, "/profile/login/"));
    }
    return {
      townName: townName,
      isOurProjectsDialogActive: isOurProjectsDialogActive,
      medcardStatus: medcardStatus,
      hasUnreadNotifications: hasUnreadNotifications,
      isUserLogged: isUserLogged,
      medcardStatusText: medcardStatusText,
      townModalStore: townModalStore,
      showDoctorsAndClinics: showDoctorsAndClinics,
      isCurrentPath: isCurrentPath,
      handleClickMedcard: handleClickMedcard,
      handleClickAppointment: handleClickAppointment,
      handleClickFavourites: handleClickFavourites,
      handleClickProfile: handleClickProfile,
      handleClickRates: handleClickRates,
      handleLogout: handleLogout,
      handleClickPatientLogin: handleClickPatientLogin,
      handleClickLpuLogin: handleClickLpuLogin,
      handleClickTown: handleClickTown
    };
  }
});